<script setup lang="ts">
import notPermission from '@/assets/images/not_permission.png';
import { ArrowRightIcon } from '@heroicons/vue/20/solid';
</script>

<template>
    <div class="flex flex-col justify-center items-center h-full font-semibold">
        <img :src="notPermission" alt="notPermission" />
        <p class="text-3xl text-gray-900 leading-9 mb-2">You don’t have permission to access this page</p>
        <p class="text-base text-gray-600 leading-6 font-normal">If you believe you should have access, please reach out to an admin or contact support</p>
        <div class="flex justify-between gap-4 mt-8">
            <router-link to="/" class="px-3.5 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white shadow-sm rounded-sm"> Go back to the homepage </router-link>
            <a href="mailto:ishveer@emailmeter.com" class="px-3.5 py-2.5 flex gap-[6px] text-gray-500 hover:text-gray-600 items-center"> Contact support <ArrowRightIcon class="w-5 h-5" /> </a>
        </div>
    </div>
</template>
